import { Axios } from 'axios';

/**
 * A function that retrieves (multiple) result object(s).
 *
 * @typeParam Out The type of object returned
 */
export type GetOperation<Out> = () => Promise<Out>;

export const getSimpleRequestFactory: <Out>(
  client: Axios,
  options?: {
    path?: string;
    permissionId?: string;
    useSubscriptionId?: boolean
  }
) => GetOperation<Out> = <Out>(
  client: Axios,
  options: {
    path?: string;
    permissionId?: string;
    useSubscriptionId?: boolean
  } = {}
) => {
  return async (): Promise<Out> => {
    const { path, permissionId, useSubscriptionId = false } = options;

    // Dynamically import to avoid circular dependency
    // eslint-disable-next-line @nx/enforce-module-boundaries
    const { useCurrentUserStore } = await import('@infuse/iam/user/store');
    const currentUserStore = useCurrentUserStore();

    if (permissionId && currentUserStore.enabled && !currentUserStore.hasPermission(permissionId, useSubscriptionId ? currentUserStore.mainSubscriptionId : undefined)) {
      // Return an empty result based on the expected type
      return {} as Out;
    }

    const response = await client.get<Out>(path!);
    return response.data;
  };
};
